import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();
    const navType = useNavigationType();

    useEffect(() => {
        // Force manual restoration so we can control it precisely
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }

        // Keep track of scroll position for each page
        const handleScroll = () => {
            sessionStorage.setItem(`scroll_pos_${window.location.pathname}`, window.scrollY.toString());
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        if (navType === 'POP') {
            // Retrieve saved position
            const savedPosition = sessionStorage.getItem(`scroll_pos_${pathname}`);
            if (savedPosition) {
                const targetY = parseInt(savedPosition, 10);

                // Retry mechanism to handle delayed content loading (images, UI shifts)
                let attempts = 0;
                const maxAttempts = 10;

                const tryScroll = () => {
                    window.scrollTo(0, targetY);

                    // If we haven't reached the target and the page is still short, retry
                    if (Math.abs(window.scrollY - targetY) > 5 && attempts < maxAttempts) {
                        attempts++;
                        setTimeout(tryScroll, 100);
                    }
                };

                // Initial short delay to let component mounting begin
                setTimeout(tryScroll, 50);
            }
        } else {
            // New navigation (PUSH/REPLACE) -> always go to top
            window.scrollTo(0, 0);
        }
    }, [pathname, navType]);

    return null;
};

export default ScrollToTop;
